"use client";

import { useGlobalBuyerProperties } from "@/hooks/use-global-buyer-properties";

/**
 * Global component to initialize buyer properties store after authentication.
 * This component should be placed right after the AuthProvider in the component tree
 * to ensure buyer properties data is available across the entire app.
 */
export function BuyerPropertiesInitializer() {
  useGlobalBuyerProperties();
  return null;
}